export default {
  postingChannels: state => {
    return state.postingChannels.map(x => x.channels);
  },
  postComments: (state) => (id) => {
    return state.postComments[id];
  },
};
